<template>
  <div id="AllCases">
    <div class="cases_slogan">全部机构</div>
    <div class="cases">
      <!-- 标语 -->
      <!-- <el-row :gutter="12">
        <el-col
          :span="6"
          v-for="(item, index) in organsList"
          :key="item.id"
          :offset="index > 0 ? 2 : 0"
        >
          <el-card @click.native="goToCases(item)" shadow="hover">
            <img :src="item.coverPictureUrl" class="image" />
            <div>
              <div class="title">{{ item.organName }}</div>
              <div class="bottom clearfix">
                <p class="time">{{ item.briefIntroduce }}</p>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row> -->
      <el-card
        @click.native="goToCases(item)"
        shadow="hover"
        v-for="item in organsList"
        :key="item.id"
      >
        <img :src="item.coverPictureUrl" class="image" />
        <div>
          <div class="title">{{ item.organName }}</div>
          <div class="bottom clearfix">
            <p class="time">{{ item.briefIntroduce }}</p>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getOrgansList } from "../axiosAPI";

export default {
  name: "AllCases",
  data() {
    return {
      organsList: [],
    };
  },
  mounted() {
    this.getOrgan();
  },
  methods: {
    // 机构列表查询
    getOrgan() {
      let query = this.$qs.stringify({
        organName: "",
        type: "1",
      });
      getOrgansList(query).then((res) => {
        if (res.data.code == 200) {
          this.organsList = res.data.item;
        }
      });
    },
    // 鼠标移入case
    moveCaseInto(e) {
      e.currentTarget.children[0].style.animation =
        "MaskToDown 0.25s linear forwards";
      e.currentTarget.children[3].style.animation =
        "TextToUp 0.25s linear forwards";
    },
    // 鼠标移出case
    CaseMovedOut(e) {
      e.currentTarget.children[0].style.animation =
        "MaskToUp 0.25s linear forwards";
      e.currentTarget.children[3].style.animation =
        "TextToDown 0.25s linear forwards";
    },
    // 跳转案例详情
    goToCases(item) {
      console.log(item, "item");
      let routerData = this.$router.resolve({ path: "/Cases" });
      // window.open(routerData.href, "_blank");
      window.open(routerData.href + "?organName=" + item.organName, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
// 混合
.CenterPage {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
#AllCases {
  // background: url("../assets/img/wallpaper3.jpg") repeat 100% 100%/100% 100%;
  background: #8e9eab; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #eef2f3,
    #8e9eab
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #eef2f3,
    #8e9eab
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  // display: flex;
  // align-items: center;
  overflow-x: hidden;
  // width: 100vw;
  min-height: 100vh;
  // padding: 0 20px;
  .cases_slogan {
    font-size: 0.4rem;
    text-align: center;
    position: relative;
    // left: 50%;
    top: 20px;
  }
}

.cases {
  // width: 100%;
  // height: 100%;
  // padding: 0 80px;
  display: flex;
  flex-wrap: wrap;
  padding: 40px 20px;
  width: 100%;
  justify-content: space-evenly;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  // align-items: center;

  .el-row {
    margin-top: 40px;
    // width: 90%;
  }
  .el-card {
    width: 420px;
    margin: 20px;
    height: 380px;
    border-radius: 8px;
  }
}
.title {
  font-size: 18px;
  font-weight: 600;
  margin-top: 10px;
}
.bottom {
  .time {
    margin-top: 20px;
    font-size: 16px;
    color: #999;
    line-height: 18px;
  }
  // span {
  //   font-size: 18px;
  //   font-weight: 600;
  // }
  // div {
  //   position: relative;
  //   top: -30px;
  // }
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  // height: 100%;
  height: 2.08rem;
  display: block;
}

.clearfix:before,
.clearfix:after {
  // display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
@media screen and (max-width: 750px) {
  .swiper {
    .cases_slogan {
      width: 100vw;
      font-size: 0.4rem;
      text-align: center;
      margin-bottom: 0.5rem;
    }
    .swiper-wrapper {
      display: flex;
      justify-content: center;
      .swiper-slide {
        .cases_item {
          width: 4rem;
          height: 4.08rem;
          margin-left: 1.3rem;
          overflow: hidden;
          position: relative;
          cursor: pointer;
          .cases_item_img {
            width: 100%;
            height: 2.08rem;
            img {
              width: 100%;
            }
          }
          .cases_item_text {
            height: 2rem;
            box-sizing: border-box;
            padding: 0.1rem 0.2rem;
            font-size: 0.2rem;
            line-height: 0.4rem;
            background-color: #efefef;
            p {
              font-size: 0.22rem;
              color: #1a1a1a;
            }
            span {
              color: #6c6c6c;
            }
          }
        }
      }
    }
  }
}
</style>
